import type { ApiInvoiceSnapshot } from '@Model';
import type { Column } from '@synqo/frontend-component-library';
import { InvoiceSnapshotRowActions } from './InvoiceSnapshotRowActions';

export interface InvoiceSnapshotRowActionsColumnProps {
    onPreview: (snapshotId: string) => void;
    onDownload: (snapshotId: string) => void;
    /** True while a document is being resolved, so a second click cannot race the first. */
    locked: boolean;
}

/** The trailing column with the row actions, neither sortable nor filterable. A click into it opens no invoice. */
// @ai-generated 2026-09-29T07:37:25+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function invoiceSnapshotRowActionsColumn({
    onPreview,
    onDownload,
    locked,
}: InvoiceSnapshotRowActionsColumnProps): Column<ApiInvoiceSnapshot> {
    return {
        name: 'rowActions',
        label: '',
        disableColumnFilter: true,
        disableColumnSort: true,
        size: 96,
        meta: { noRowClick: true },
        renderCell: ({ rowData }) => (
            <InvoiceSnapshotRowActions
                snapshotId={rowData.id}
                onPreview={onPreview}
                onDownload={onDownload}
                locked={locked}
            />
        ),
    };
}
